/* eslint-disable no-use-before-define */
import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

const AutocompleteMultipleDropdown = ({ id, selectData, onChange, label, selectedData }) => {
  return (
    <Autocomplete
      multiple
      id={`autocomplete--multiple-selector-${id}`}
      options={selectData}
      value={selectedData}
      getOptionLabel={(option) => option.display}
      style={{ width: '100%' }}
      onChange={(event, itemSelected) => {
        onChange(itemSelected);
      }}
      renderInput={(params) => (
        <TextField {...params} variant="outlined" label={label} placeholder={label} />
      )}
    />
  );
};

AutocompleteMultipleDropdown.propTypes = {
  id: PropTypes.string,
  selectData: PropTypes.arrayOf(PropTypes.shape({})),
  selectedData: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func,
  label: PropTypes.string,
  multiple: PropTypes.bool,
};

export default AutocompleteMultipleDropdown;
